/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { SeriesSummaryModel } from './SeriesSummaryModel';
import {
    SeriesSummaryModelFromJSON,
    SeriesSummaryModelFromJSONTyped,
    SeriesSummaryModelToJSON,
} from './SeriesSummaryModel';

/**
 * 特集枠のアイテム
 * @export
 * @interface TopItemModelTopItemInner
 */
export interface TopItemModelTopItemInner {
    /**
     * 特集アイテムのID
     * @type {number}
     * @memberof TopItemModelTopItemInner
     */
    id?: number;
    /**
     * 特集アイテムのタイトル
     * @type {string}
     * @memberof TopItemModelTopItemInner
     */
    title?: string;
    /**
     * 特集アイテムをクリックすると、遷移されるURL
     * @type {string}
     * @memberof TopItemModelTopItemInner
     */
    itemUrl?: string;
    /**
     * 
     * @type {ImageModel}
     * @memberof TopItemModelTopItemInner
     */
    spImage?: ImageModel;
    /**
     * 
     * @type {ImageModel}
     * @memberof TopItemModelTopItemInner
     */
    pcImage?: ImageModel;
    /**
     * 
     * @type {SeriesSummaryModel}
     * @memberof TopItemModelTopItemInner
     */
    series?: SeriesSummaryModel;
    /**
     * 画像の大きさ *1：大　*2：中　*3：小
     * @type {number}
     * @memberof TopItemModelTopItemInner
     */
    size?: number;
}

/**
 * Check if a given object implements the TopItemModelTopItemInner interface.
 */
export function instanceOfTopItemModelTopItemInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TopItemModelTopItemInnerFromJSON(json: any): TopItemModelTopItemInner {
    return TopItemModelTopItemInnerFromJSONTyped(json, false);
}

export function TopItemModelTopItemInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopItemModelTopItemInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'itemUrl': !exists(json, 'itemUrl') ? undefined : json['itemUrl'],
        'spImage': !exists(json, 'spImage') ? undefined : ImageModelFromJSON(json['spImage']),
        'pcImage': !exists(json, 'pcImage') ? undefined : ImageModelFromJSON(json['pcImage']),
        'series': !exists(json, 'series') ? undefined : SeriesSummaryModelFromJSON(json['series']),
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function TopItemModelTopItemInnerToJSON(value?: TopItemModelTopItemInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'itemUrl': value.itemUrl,
        'spImage': ImageModelToJSON(value.spImage),
        'pcImage': ImageModelToJSON(value.pcImage),
        'series': SeriesSummaryModelToJSON(value.series),
        'size': value.size,
    };
}

